import React, { useEffect } from "react";
import Edelicon from "@frameworks/web/components/generic/Edelicon";
const Toaster = (props) => {
    useEffect(() => {
        setTimeout(() => {
            props.setShow(false);
        }, 3000);
    }, [props.show]);
    return (React.createElement(React.Fragment, null, props.show && (React.createElement("div", { className: `p-10 d-inline-flex brdradius-5 ${props.success ? "bg_light_green1" : "bg_cream"} ${props.parentClassName}` },
        React.createElement("div", { className: `DMSanN_14_400 d-flex justify-content-center gap-1 ${props.success ? "txt_green1" : "txt_yellow1"}` },
            props.success ? (React.createElement("i", { className: "edel-icon-success-rounded-tick" })) : (React.createElement(Edelicon, { className: "edel-icon-danger danger-icon", paths: 3 })),
            React.createElement("div", { className: "d-flex align-items-center" }, props === null || props === void 0 ? void 0 : props.message))))));
};
export default Toaster;
